// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__R2gs_","checkboxCol":"Table_checkboxCol__2aF25","emailCol":"Table_emailCol__3yLIX","actionCol":"Table_actionCol__3qjdg"};